import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import useStyles from './styles';

type Props = {
    content: string;
    className?: string;
};

const headingToId = (txt: string) => txt.toLowerCase().replace(/[^\w]+/g, '-');

const MarkdownContent: React.FC<Props> = ({ content, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    h2: function HeadingRenderer({ node: _node, children, ...props }) {
                        return (
                            <h2 id={headingToId(String(children))} {...props}>
                                {children}
                            </h2>
                        );
                    }
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
};

export default MarkdownContent;
